<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <!-- Sous 768 px le tableau passe en mode empilé et son en-tête (qui
               contient le bouton d'ajout version bureau) est masqué : on affiche
               alors le bouton au-dessus du tableau, avec son propre modal. -->
          <div class="d-md-none text-right mb-2">
            <CategoryModalAdd @ok="refreshAfterAdd" :host="host" modal-id="modal-CategoryAddMobile" />
          </div>
              <div class="table-responsive datatable-vue">
                <b-modal id="alert-category" title="Confirmation" @ok="deleteRow()">
                  <p class="my-4">Are you sure you want to delete this category?</p>
                </b-modal>
                <b-table
                  ref="tableCategory"
                  sticky-header
                  striped
                  hover
                  responsive
                  class="text-center"
                  bordered
                  head-variant="light"
                  show-empty
                  stacked="md"
                  :items="listData"
                  :fields="tablefields"
                  :filter="filter"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @filtered="onFiltered"
                  :select-mode="selectMode"
                  :selectable="true"
                >
                  <template v-slot:cell(actions)="item">
                    <div class="row-actions">
                      <span @click="getIndex(item.item.id,item.item.title, item.index)">
                        <CategoryModalEdit 
                        :id = "item.index" 
                        :category="item.item.category" 
                        :description="item.item.description" 
                        :offer="item.item.offer" 
                        :image="item.item.image" 
                        :metaTitle="item.item.metaTitle" 
                        :metaDescription="item.item.metaDescription" 
                        :metaKeywords="item.item.metaKeywords"
                        :host="host"
                        @ok="refreshAfterEdit"/>
                      </span>
                      <button type="button" class="icon-btn icon-btn-danger" title="Delete category" v-b-modal.alert-category @click="getIndex(item.item.id,item.item.title, item.index)">
                        <feather type="trash-2" size="16"></feather>
                      </button>
                    </div>
                  </template>
                  <template v-slot:head(actions)>
                    <CategoryModalAdd @ok="refreshAfterAdd" :host="host"/>
                  </template>
                </b-table>
              </div>
              <b-col md="12" class="my-1 pagination-justify p-0">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    class="mt-4"
                  ></b-pagination>
              </b-col>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import CategoryModalAdd from "./CategoryModalAdd.vue";
import CategoryModalEdit from "./CategoryModalEdit.vue";
export default {
  props:['Data','host'],
  components: { CategoryModalAdd , CategoryModalEdit},
  data() {
    return {
      tablefields: [
        { key: "category", label: "Category", sortable: true },
        { key: "actions" }
      ],
      vlistData: [],
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      selectMode: "single",
      categoryindex:null,
      category:null,
      categoryid:null,
      categoryindex:null
    };
  },
  computed: {
  listData(){
    return this.Data ? this.Data : [];
  },
  sortOptions() {
      return this.tablefields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
  },
  selectedRows() {
      return this.listData.filter(item => item.delete);
  },
  mounted() {
    if (this.listData) this.totalRows = this.listData.length;
    }
  },
  methods: {
    getIndex(id, title, index) {
      this.category = title;
      this.categoryid = id;
      this.categoryindex = index;
    },
    deleteRow() {
      this.listData.splice(this.categoryindex, 1);
      this.categoryindex = null;
      this.$emit("deleteCat", this.listData);
    },
    onFiltered(filteredItems) {
      if (filteredItems){
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      }
    },
    refreshAfterAdd(e){
      this.listData.push(e);
      this.$emit('ok',this.listData);
      this.$refs.tableCategory.refresh();
    },
    refreshAfterEdit(e){
      this.listData[this.categoryindex]=e;
      this.$emit('ok',this.listData);
      this.$refs.tableCategory.refresh();
    },
    ok(){
      
    }
  }
};
</script>

<style lang="scss" scoped>
table.text-center * {
  text-align: center;
}
</style>